import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import loading from "../../assets/images/DesignViewerLoader/cubeloading.gif";
import ConversionFailedLoader from "../../assets/images/DesignViewerLoader/ConversionFailedLoader.svg";
import ConversionNotStartedLoader from "../../assets/images/DesignViewerLoader/ConversionNotStartedLoader.svg";
import { SOMETHING_WENT_WRONG } from "@Services/constants";
import { getAllNotificationPageUrl } from "@Services/utils/helpers";
import { supportTicketTypes } from "@Helpers";
import { shouldShowSupport, getSupportContactHref } from "@Utils";
import { useSelector } from "react-redux";
import { RootState } from "@Reducers/index";

function Loader({ conversionProgress, fileType }: any) {
  const { t } = useTranslation();
  const [data, setData]: any = useState<any>(null);
  const portalData = useSelector((state: RootState) => state.portalData);

  const supportHref = shouldShowSupport(portalData)
    ? getAllNotificationPageUrl({
        section: "support",
        supportType: supportTicketTypes.ASK_QUESTION,
        referrerUrl: window.location.href,
      })
    : getSupportContactHref();

  useEffect(() => {
    const EXCEL_TYPE = ["xls", "xlsx", "csv", "xlsm"];
    const DOC_TYPE = ["doc", "docx", "rtf", "txt", "htm", "html", "sfdt"];
    const PPT_TYPE = ["pptx"];
    const data: any = {};
    if (EXCEL_TYPE.includes(fileType) || DOC_TYPE.includes(fileType) || PPT_TYPE.includes(fileType)) {
      if (conversionProgress == "IN_PROGRESS") {
        data.header = "Please Wait...";
        data.headerDescription = "This file is being processed by our servers.";
        data.image = loading;
      } else if (conversionProgress == "ERRORED") {
        data.header = SOMETHING_WENT_WRONG;
        data.headerDescription = "Either File is corrupted or not a supported format";
        data.headerDescription1 = "Error Logs.";
        data.image = ConversionFailedLoader;
        data.footer = `This may have happened due to a number of reasons and/or factors.
          Please `;
        data.footer1 = "read Documentation";
        data.footer2 = " for possible reasons of failure and ways to fix.";
        data.support = "If the issue still persists, please";
      } else if (conversionProgress == "NOT_STARTED") {
        data.header = "Please Wait!";
        data.headerDescription = "Our servers are busy at the moment.";
        data.image = ConversionNotStartedLoader;
      }
    } else if (conversionProgress == "IN_PROGRESS") {
      data.header = "Conversion in Progress...";
      data.headerDescription = "This file is being processed by our servers.";
      data.image = loading;
      data.footer = `It may take anywhere between a few seconds to a few minutes for the processing to complete. You will get a notification once the processing is complete. 
          You can navigate to a different screen and continue your other work without affecting this process.`;
      data.support = "If it is taking really long, please ";
    } else if (conversionProgress == "ERRORED") {
      data.header = "Conversion Failed!";
      data.headerDescription = "The file failed to convert.";
      data.headerDescription1 = "Error Logs.";
      data.image = ConversionFailedLoader;
      data.footer = `This may have happened due to a number of reasons and/or factors.
          Please `;
      data.footer1 = "read Documentation";
      data.footer2 = " for possible reasons of failure and ways to fix.";
      data.support = "If the issue still persists, please";
    } else if (conversionProgress == "NOT_STARTED") {
      data.header = "Conversion Not Started!";
      data.headerDescription = "Our servers are busy at the moment.";
      data.image = ConversionNotStartedLoader;
      data.footer = `It may take anywhere between a few seconds to a few minutes for the processing to start. You will get a notification once the processing is complete.
          You can navigate to a different screen and continue your other work without affecting this process.`;
      data.support = "If it is taking really long, please ";
    }
    setData(data);
  }, [conversionProgress, fileType]);

  // const handleRedirectToSubscription = () => {
  //   navigate('/portalSettings/subscription');
  // };

  return (
    <div className="absolute grid items-center overflow-auto z-10 h-full w-full bg-white">
      <div className="flex flex-col gap-6 h-maxContent justify-center items-center overflow-auto">
        <div className="text-6xl text-center flex justify-center">{data?.header}</div>
        <div className="text-2xl text-center flex justify-center ">
          <span>{data?.headerDescription}</span>
          {/* <span className="font-bold text-primary_gradient_color1"><a href="" target="_blank" rel="noreferrer">{data?.headerDescription1}</a></span> */}
        </div>
        <img src={data?.image} className="m-auto w-80 after900H:w-auto" />
        <div
          className={`block text-lg text-center leading-normal 
        ${
          conversionProgress == "ERRORED"
            ? "md:w-140.25"
            : conversionProgress == "NOT_STARTED"
              ? "xl:w-282.5"
              : "xl:w-287.5"
        } w-auto`}
        >
          <span>{data?.footer}</span>
          <span className="font-bold text-primary_gradient_color1">
            <a
              href="https://support.cube.ms/Guidelines-to-upload-Revit-files-22dde45767ab81e08a4de222237f3dab"
              target="_blank"
              rel="noreferrer"
            >
              {data?.footer1}
            </a>
          </span>
          <span>{data?.footer2}</span>
        </div>
        <div className="text-lg text-center leading-normal">
          {/* {portalData.trialEndsOn && portalData.trialEndsOn < Date.now() && (
            <div className="pb-4" onClick={handleRedirectToSubscription}>
              Trial users have a limited conversion bandwidth. Experience faster conversions with a
              <span className="ps-1 cursor-pointer font-bold text-primary_gradient_color1">{t("paid plan")}</span>
            </div>
          )} */}
          <span>{data?.support} </span>
          <span className="font-bold text-primary_gradient_color1">
            <a href={supportHref} target="_blank" rel="noreferrer">
              {t("Contact Support.")}
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Loader;
